import { Link } from 'react-router-dom';
import type { OperatorTaskContextResponse } from '@/core/generated/api';
import { isTaskChatRelated } from '../model/chatContext';
import classes from './TaskRelatedLinks.module.scss';

interface TaskRelatedLinksProps {
    context?: OperatorTaskContextResponse;

    /** Открывает краткую карточку заказа вместо перехода на страницу */
    onOpenOrder?: (orderId: string) => void;
}

/** Открывает связанные с задачей заказ и диалог */
export const TaskRelatedLinks = ({ context, onOpenOrder }: TaskRelatedLinksProps) => (
    <div
        className={classes.links}
        onClick={(event) => event.stopPropagation()}
    >
        {!context?.order && !context?.chat &&
            <span>Без привязки</span>
        }
        {context?.order && (context.order.availability?.id === 'available' && context.order.id
            ? (
                onOpenOrder
                    ? <button
                        type="button"
                        className={classes.orderButton}
                        onClick={() => { if (context.order?.id) onOpenOrder(context.order.id); }}
                    >
                        {context.order.label ?? `Заказ № ${context.order.orderNumber}`}
                    </button>
                    : <Link to={`/orders/${context.order.id}`}>{context.order.label ?? `Заказ № ${context.order.orderNumber}`}</Link>
            )
            : <span>Заказ недоступен</span>)}
        {context?.chat && (context.chat.availability?.id === 'available' && isTaskChatRelated(context.chat)
            ? (
                <Link to={context.chat.companionAppUserId
                    ? `/chats?${new URLSearchParams({
                        app_user_id: context.chat.companionAppUserId,
                        role: context.chat.companionRole?.id ?? '',
                        chat_id: context.chat.chatId ?? '',
                    })}`
                    : `/chat-dialogs?${new URLSearchParams({
                        source: 'salebot',
                        dialogId: context.chat.chatId ?? ''
                    })}`
                }>
                    {context.chat.label ?? 'Открыть чат'}
                </Link>
            )
            : <span>Чат недоступен</span>)}
    </div>
);
